import React from "react";
import { useNavigate } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Company Info */}
        <div className="footer-section">
          <h3>EPC Infra</h3>
          <p>
            Leading Transmission & Infrastructure EPC company delivering
            high-quality engineering solutions across India.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li onClick={() => navigate("/")}>Home</li>
            <li>Services</li>
            <li>Projects</li>
            <li onClick={() => navigate("/contact-feedback")}>Contact</li>
          </ul>
        </div>

        {/* Social + CTA */}
        <div className="footer-section">
          <h4>Connect</h4>

          <div className="social-links">
            <span>Twitter</span>
            <span>LinkedIn</span>
            <span>Facebook</span>
          </div>

          {/* CTA Button */}
          <button
            className="footer-cta"
            onClick={() => navigate("/contact-feedback")}
          >
            Get in Touch
          </button>
        </div>

      </div>

      <div className="footer-bottom">
        © 2026 Ramcharan Constructions. All rights reserved.
      </div>
    </footer>
  );
}